module.exports = __webpack_public_path__ + "static/media/ryan_yeo.f7a1985c.png";